import type { enApprovals } from '../en/approvals';

export const idApprovals: Record<keyof typeof enApprovals, string> = {
  'approvals.status.pending': 'Menunggu',
  'approvals.status.approved': 'Disetujui',
  'approvals.status.rejected': 'Ditolak',
  'approvals.status.cancelled': 'Dibatalkan',
  'approvals.step.waiting': 'Belum',
  'approvals.step.pending': 'Menunggu keputusan',
  'approvals.step.approved': 'Disetujui',
  'approvals.step.rejected': 'Ditolak',
  'approvals.step.cancelled': 'Dibatalkan',
  'approvals.steps.title': 'Langkah persetujuan',
  'approvals.steps.desc':
    'Kebijakan {policy} (versi {version}), dibekukan saat permintaan diajukan.',
  'approvals.steps.stepNo': 'Langkah {n}',
  'approvals.steps.needs': 'Perlu {permission}',
  'approvals.steps.needsRole': 'Perlu {permission} · peran {role}',
  'approvals.steps.anyRole': 'peran apa saja',
  'approvals.steps.assigned': 'Dieskalasi ke {name}',
  'approvals.steps.escalationReason': 'Eskalasi: {reason}',
  'approvals.steps.decidedBy': '{name} · {time}',
  'approvals.steps.onBehalfOf': 'atas nama {name}',
  'approvals.steps.note': 'Catatan: {note}',
  'approvals.steps.initiator': 'Diajukan oleh {name} · {time}',
  'approvals.steps.none': 'Belum ada langkah persetujuan untuk permintaan ini.',
  'approvals.perm.procurement.approve': 'Persetujuan pembelian',
  'approvals.perm.budget.approve': 'Persetujuan anggaran',
  'approvals.perm.ap.approve': 'Persetujuan utang usaha',
  'approvals.perm.ap.verify': 'Verifikasi utang usaha',
  'approvals.perm.inventory.approve': 'Persetujuan persediaan',
  'approvals.refusal.initiator': 'Anda yang mengajukan; orang lain harus memutuskan.',
  'approvals.refusal.already_approved':
    'Anda sudah menyetujui langkah sebelumnya; orang lain harus memutuskan langkah ini.',
  'approvals.refusal.missing_permission':
    'Peran Anda tidak memiliki izin yang diperlukan langkah ini.',
  'approvals.refusal.missing_role': 'Langkah ini memerlukan peran tertentu yang tidak Anda miliki.',
  'approvals.refusal.not_assigned': 'Langkah ini sudah dieskalasi ke orang lain.',
  'approvals.refusal.not_pending': 'Permintaan ini tidak lagi menunggu keputusan.',
  'approvals.refusal.generic': 'Anda tidak dapat memutuskan langkah ini.',
  'approvals.approve': 'Setujui',
  'approvals.approving': 'Menyetujui…',
  'approvals.reject': 'Tolak',
  'approvals.rejecting': 'Menolak…',
  'approvals.approveTitle': 'Setujui {label}?',
  'approvals.approveBody': 'Ini memutuskan langkah {n}: {step}.',
  'approvals.approveNote': 'Catatan',
  'approvals.rejectTitle': 'Tolak {label}?',
  'approvals.rejectBody': 'Pengaju melihat alasan Anda dan dapat mengubah lalu mengajukan ulang.',
  'approvals.rejectReason': 'Alasan',
  'approvals.approved': 'Disetujui.',
  'approvals.rejected': 'Ditolak.',
  'approvals.budgetExceeded': 'Melebihi anggaran: tersedia {available}, diminta {requested}.',
  'approvals.amount': 'Jumlah',
  'approvals.domain.purchase_request': 'Permintaan pembelian',
  'approvals.domain.purchase_order': 'Pesanan pembelian',
  'approvals.domain.supplier_invoice': 'Faktur pemasok',
  'approvals.domain.ap_payment': 'Pembayaran pemasok',
  'approvals.domain.waste': 'Waste',
  'approvals.domain.stock_count': 'Stok opname',
};
